var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusSquareOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00008 3.16666C3.53984 3.16666 3.16675 3.53975 3.16675 3.99999V12C3.16675 12.4602 3.53984 12.8333 4.00008 12.8333H12.0001C12.4603 12.8333 12.8334 12.4602 12.8334 12V3.99999C12.8334 3.53975 12.4603 3.16666 12.0001 3.16666H4.00008ZM2.16675 3.99999C2.16675 2.98747 2.98756 2.16666 4.00008 2.16666H12.0001C13.0126 2.16666 13.8334 2.98747 13.8334 3.99999V12C13.8334 13.0125 13.0126 13.8333 12.0001 13.8333H4.00008C2.98756 13.8333 2.16675 13.0125 2.16675 12V3.99999ZM5.50008 7.99999C5.50008 7.72385 5.72394 7.49999 6.00008 7.49999H7.50008V5.99999C7.50008 5.72385 7.72394 5.49999 8.00008 5.49999C8.27622 5.49999 8.50008 5.72385 8.50008 5.99999V7.49999H10.0001C10.2762 7.49999 10.5001 7.72385 10.5001 7.99999C10.5001 8.27613 10.2762 8.49999 10.0001 8.49999H8.50008V9.99999C8.50008 10.2761 8.27622 10.5 8.00008 10.5C7.72394 10.5 7.50008 10.2761 7.50008 9.99999V8.49999H6.00008C5.72394 8.49999 5.50008 8.27613 5.50008 7.99999Z",
    fill: "content"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSquareOutline);
export default __webpack_public_path__ + "static/media/plusSquareOutline.b74a399ef98a2ce2fcdfe44e4b80c921.svg";
export { ForwardRef as ReactComponent };